import Button from '../core/Button';
import { UserProfileDTO } from '@/api/auth';
import { cn } from '@/helpers/classnames';
import { forwardRef } from 'react';
import { RoleIcon } from '../RoleIcon';
import { RoleName } from '../RoleName';
import { isProfileInvalid } from '@/helpers/invalidProfiles';
import { FormattedMessage } from 'react-intl';
import { IconWarningTriangle } from '@/icons';

export const ProfileButton = forwardRef<
  HTMLButtonElement,
  {
    profile: UserProfileDTO | null;
    selected?: boolean;
    onClick: () => void;
    className?: string;
  }
>(({ profile, selected, onClick, className }, ref) => {
  if (!profile) return null;

  const invalid = isProfileInvalid(profile.id);

  return (
    <div className="flex w-full flex-col gap-1">
      <Button
        ref={ref}
        variant={selected ? 'filled' : 'outline'}
        className={cn(
          'size-full min-w-0 gap-4 overflow-hidden font-normal',
          invalid && 'border-yellow-500',
          className,
        )}
        onClick={onClick}
      >
        <RoleIcon roleId={profile.role_id} className="size-8 min-w-8" />
        <div className="flex w-full min-w-0 flex-col items-start text-left">
          <p className="w-full truncate">
            <RoleName roleId={profile.role_id} />
          </p>
          <p className="w-full truncate opacity-70">{profile.organization}</p>
        </div>
        {invalid && (
          <IconWarningTriangle className="size-6 min-w-6 text-yellow-500" />
        )}
      </Button>
      {invalid && (
        <p className="flex items-center gap-2 px-2 text-xs text-text-700">
          <IconWarningTriangle className="size-4 min-w-4" />
          <FormattedMessage defaultMessage="Den här profilen är kanske inte längre tillgänglig. Detta beror ofta på att du inte längre har tillgång till organisationen." />
        </p>
      )}
    </div>
  );
});

ProfileButton.displayName = 'ProfileButton';
